export enum GeneratedDocumentLabRecordType {
  LegacyLab = 'legacy_lab',
  PreviousProvider = 'previous_provider',
}
